<template>
  <div>
    <!-- 顶部导航 -->
    <TopNav></TopNav>
    <!-- 楼宇对讲轮播图 -->
    <IntercomBanner></IntercomBanner>
    <!-- 楼宇对讲优势 -->
    <IntercomAdvantage></IntercomAdvantage>
    <!-- 楼宇对讲智能硬件描述 -->
    <IntercomDescribe></IntercomDescribe>
    <!-- 方案场景描述 -->
    <IntercomScene></IntercomScene>
    <!-- 底部导航 -->
    <ButtonNav></ButtonNav>
  </div>
</template>

<script>
import { reactive } from "vue";

import TopNav from "../../../../components/mobile/components/TopNav.vue";
import ButtonNav from "../../../../components/mobile/components/BottomNav.vue";
import IntercomBanner from "../../../../components/mobile/Programme/IntercomComponents/IntercomBanner.vue";
import IntercomAdvantage from '../../../../components/mobile/Programme/IntercomComponents/IntercomAdvantage.vue'
import IntercomDescribe from '../../../../components/mobile/Programme/IntercomComponents/IntercomDescribe.vue'
import IntercomScene from '../../../../components/mobile/Programme/IntercomComponents/IntercomScene.vue'

export default {
  setup() {
    return reactive({});
  },
  components: {
    TopNav,
    ButtonNav,
    IntercomBanner,
    IntercomAdvantage,
    IntercomDescribe,
    IntercomScene,
  },
};
</script>

<style scoped>
</style>
